import { Modal, Button } from "flowbite-react";
import { HiExclamation } from "react-icons/hi";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: string;
}

export default function KbDeleteConfirmModal({ open, onClose, onConfirm, message }: Props) {
  const { t } = useTranslation(["common"]);

  return (
    <Modal show={open} onClose={onClose} size="md" popup>
      <Modal.Header />
      <Modal.Body>
        <div className="text-center">
          <HiExclamation className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
          <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
            {message}
          </h3>
          <div className="flex justify-center gap-4">
            <Button color="failure" onClick={onConfirm}>
              {t("common:yes")}
            </Button>
            <Button color="gray" onClick={onClose}>
              {t("common:no")}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
